import { render } from "./MyProject.vue?vue&type=template&id=2f96a64c"
import script from "./MyProject.vue?vue&type=script&lang=js"
export * from "./MyProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__